<pt-breadcrumbs current="Tools" class="bg-white" />
<div class="border-b border-solid border-slate-300"></div>

<div class="wrapper">
  <div class="flex flex-col gap-8">
    @for (group of groups; track group.group) {
      <div class="flex flex-col gap-2">
        <h2 class="!m-0 text-xl !font-bold">{{ group.group }}</h2>
        <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          @for (tool of group.items; track tool.name) {
            <a
              [routerLink]="tool.routerLink"
              class="flex flex-col gap-1 rounded-md border border-solid border-slate-100 bg-white p-4 no-underline shadow-sm transition-shadow hover:shadow-md"
            >
              <h3 class="!m-0 !font-bold">{{ tool.name }}</h3>
              <div class="text-sm text-slate-500">
                {{ tool.description }}
              </div>
            </a>
          }
        </div>
      </div>
    }
  </div>
</div>
